// extracted by mini-css-extract-plugin
export var divider = "_w6-0";